import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteReportingCompany, getPaginatedPayersList, getReportingCompanyDetails } from "../FileBoiSaga";
import {componentKey as fileBoiComponentKey, setGridSelectedPayers, setIsAddNewBenefiarySelected, setPayerListPaginationState, setReloadPayersList, setReportingCompanyDetailId, setReportingCompanyScreenNxtBtnClicked, updateBoiFormFields} from '../FileBoiSlice';
import RichGrid from "../../../../components/richgrid/RichGrid";
import Label from "../../../../components/label/Label";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import styles from '../FileBoi.Styles';
import Heading from "../../../../components/heading/Heading";
import { HEADING } from "../../../../components/heading/constants/constants";
import Button from "../../../../components/button/Button";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Icons from "../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import { BOI_FORM_STEPS, FILE_BOI_LOADING_STATES, FILE_BOI_LOADING_STATES_MESSAGE_MAP } from "../../constants";
import Loadable from "../../../../components/loadable/Loadable";
import TextInput from "../../../../components/input/textinput/TextInput";
import useDelayedAction from "../../../../../libs/customhooks/useDelayedAction";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import { BOI_REPORTING_SECTION_ROUTES } from "../../../constants/constants";

export default function ReportingCompanies(){

    const { loadingState, reportingCompanyLoadingState, payerListPaginationState, payersList, gridSelectedPayers, boiFormFields, reloadPayersList, defaultReporingCompanyFieldsArr } = useSelector(state => state[fileBoiComponentKey])
    const [searchedReportingCompany, setSearchedReportingCompany] = useState('');
    const dispatch = useDispatch();

    const REPORTING_COMPANIES_GRID_COLUMNS = [
        {
            field: "payerId",
            header: <Label weight={LABEL_WEIGHT[700]}>Reporting Company</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.LastName ?? "" }</span>
        },
        {
            field: "tin",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.IdNumber }</span>
        },
        {
            field: "actions",
            header: <Label weight={LABEL_WEIGHT[700]}>Actions</Label>,
            renderLogic: (row, idx) => <div style={styles.gridActions}>
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit'} onClickCb={() => dispatch(getReportingCompanyDetails({reportingCompanyDetailId: row?.PayerDetailId, boiFormFields: boiFormFields}))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} /></Button>
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Delete'} onClickCb={() => dispatch(deleteReportingCompany({PayerDetailId: row?.PayerDetailId}))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button>
            </div>
        },
    ]

    useEffect(() => {
        handleGetPaginatedPayersList(payerListPaginationState?.PageNumber, payerListPaginationState?.PageSize, payerListPaginationState)
    }, [])

    useEffect(() => {
        if(reloadPayersList){
            handleGetPaginatedPayersList(payerListPaginationState?.PageNumber, payerListPaginationState?.PageSize, payerListPaginationState)
            dispatch(setReloadPayersList(false))
        }
    }, [reloadPayersList])

    useEffect(() => {
        dispatch(setPayerListPaginationState({PageNumber: 1, Skip: 0}))
        handleGetPaginatedPayersList(1, payerListPaginationState?.PageSize, {...payerListPaginationState, PageNumber: 1, Skip: 0})
    } ,[searchedReportingCompany])

    const handleGetPaginatedPayersList = useDelayedAction((pageNumber, pageSize, payerListPaginationState = payerListPaginationState) => {
        dispatch(getPaginatedPayersList({
            ...payerListPaginationState,
            PageSize: pageSize,
            PageNumber: pageNumber,
            formName: "FormBoi",
            FilterText: searchedReportingCompany,
        }))
    })

    const updateSelectedGridRecord = (selectedRecordsFromGrid, selectedPayer) => {
        if(selectedPayer.length > 0){
            const index = selectedRecordsFromGrid.findIndex(item => item?.PayerDetailId === selectedPayer[0].PayerDetailId);
            if (index !== -1) {
                selectedRecordsFromGrid.splice(index, 1);
            }
        }
        dispatch(setGridSelectedPayers(selectedRecordsFromGrid))
    }

    const handleNextBtnClick = () => {
        if(gridSelectedPayers.length > 0){
            dispatch(getReportingCompanyDetails({reportingCompanyDetailId: gridSelectedPayers[0]?.PayerDetailId, boiFormFields: boiFormFields}))
        }else{
            dispatch(addNotifications({ heading: "Error",  message: "Please select a reporting company first to proceed to the next page", variant: TOASTER_VARIANT.WARNING}))
        }
    }

    const handleAddNewReortingCompanyClk = () => {
        dispatch(updateBoiFormFields({[BOI_FORM_STEPS.REPORTING_COMPANY]: defaultReporingCompanyFieldsArr}))
        dispatch(setIsAddNewBenefiarySelected(true))
    }
    
    return <>
      <Breadcrumbs items={[
                        { text: 'Home', link: '/' },
                        { text: 'BOI Reporting', link: `/${BOI_REPORTING_SECTION_ROUTES.BOIREPORTING}` },
                        { text: 'File BOI' },
                    ]} 
                />
        <Heading type={HEADING.H1} customStyle={styles.mainTitle}>File BOI</Heading>
        <Heading type={HEADING.H2} customStyle={styles.selectReportingCompanytitle}>Select Reporting Company</Heading>
        <div style={styles.addBtnDiv}>
            <div style={styles.flexOne}>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search with reporting company name: </Label>
                <TextInput
                    type={'text'}
                    placeHolder={"Reporting Company"}
                    name={'reportingCompany'}
                    value={searchedReportingCompany}
                    onChangeCb={(e) => setSearchedReportingCompany(e.target.value)}
                />
            </div>
            <Button style={styles.addBtnStyles} type={BUTTON_TYPE.PRIMARY} onClickCb={() => handleAddNewReortingCompanyClk()}>Add New Reporting Company</Button>
        </div>
        <Loadable currentState={reportingCompanyLoadingState.state} loadingStates={[FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_LOADING]} messageMap={FILE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
            <RichGrid
                selectable={true}
                showHeaderSelectionCheckbox={false}
                data={payersList}
                columns={REPORTING_COMPANIES_GRID_COLUMNS}
                extractRowKey={(row) => row?.PayerDetailId}
                selectedRows={gridSelectedPayers}
                onSelectionChangeCallBack={(selectedData) => updateSelectedGridRecord(selectedData, gridSelectedPayers)}
                paginationProps={{
                    skip: payerListPaginationState?.Skip,
                    take: payerListPaginationState?.PageSize,
                    takeOptions: ROW_SELECTION_OPTIONS,
                    onChangeTakeCb: (newTake) => {
                        dispatch(setPayerListPaginationState({PageSize: newTake, Skip: 0, PageNumber: 1}))
                        handleGetPaginatedPayersList(1, newTake, {...payerListPaginationState, PageSize: newTake, Skip: 0, PageNumber: 1})
                    },
                    total: payerListPaginationState?.totalRecords,
                    onChange: (take, t) => {
                        dispatch(setPayerListPaginationState({PageSize: take, Skip: t, PageNumber: (t / take) + 1}))
                        handleGetPaginatedPayersList((t / take) + 1, take, {...payerListPaginationState, PageSize: take, Skip: t, PageNumber: (t / take) + 1})
                    },
                }}
            />
            <div style={styles.addBtnDiv}>
                <Button onClickCb={handleNextBtnClick}>Next</Button>
            </div>
        </Loadable>
    </>
}